<template>
  <v-app>
    <v-content>
      <v-container fluid ma-0 pa-0 v-resize="onResize">
        <v-img src="../../static/img/background_small.jpg" :width="x" :height="y" class="bgimage">
          <nav class="navbar navbar-light" style="height: 10px;">
            <a class="navbar-brand" href="#">
              <img src="../assets/img/logo.png" width="60" height="40" class="d-inline-block align-top" alt="">
              <div style="display: inline-block; padding-left: 5px; color: white;font-weight: 700;">
                <span> KENYA COFFEE </span>
              </div>
            </a>
            <div id="navbarNav" style="margin-right: 200px;">
              <ul class="nav justify-content-end">
                <li class="nav-item">
                  <a class="nav-link links" href="/">Home</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link links" href="#">Latest News</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link links" href="#">About Us</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link links active" href="/contactus">Contact Us</a>
                </li>
              </ul>
            </div>
          </nav>
        </v-img>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import Swal from 'sweetalert2'
import config from '@/config'
import axios from 'axios'

export default {
  name: 'QrCode',
  data: function () {
    return {
      warrantNumber: '',
      message: ''
    }
  },
  created () {
    this.showConfirmationDialog()
  },
  mounted () {
    this.warrantNumber = this.$route.params.warrant
  },
  methods: {

//       const { value: passkey } = await Swal.fire({
//   title: 'PassKey Validation',
//   text: 'Please enter your generated passKey.',
//   icon: 'warning',
//   input: 'text',  // Adds a text input field
//   inputPlaceholder: 'Enter PassKey',
//   inputAttributes: {
//     autocapitalize: 'off'
//   },
//   showCancelButton: true,
//   confirmButtonText: 'Yes, proceed',
//   cancelButtonText: 'No, cancel',
//   preConfirm: (passkey) => {
//     if (!passkey) {
//       Swal.showValidationMessage('PassKey is required!');
//     }
//     return passkey;
//   }
// });


async showConfirmationDialog() {
  const { value: passkey } = await Swal.fire({
    title: 'PassKey Validation',
    text: 'Kindly enter warrant Passkey.',
    icon: 'warning',
    input: 'text', // Adds a text input field
    inputPlaceholder: 'Enter PassKey',
    inputAttributes: {
      autocapitalize: 'off'
    },
    showCancelButton: true,
    confirmButtonText: 'Yes, proceed',
    cancelButtonText: 'No, cancel',
    preConfirm: (passkey) => {
      if (!passkey) {
        Swal.showValidationMessage('PassKey is required!');
      }
      return passkey;
    }
  });

  if (!passkey) {
    console.log('User canceled PassKey entry');
    return;
  }

  try {
    // Call validation endpoint
    // const response = await axios.post(`${config.serverURI}/warrant/validatePassKey?key={passkey}`);
    const response = await axios.post(`${config.serverURI}/warrant/validatePassKey?key=${passkey}`);


    if (response.data.error) {
      await Swal.fire('Error!', 'Invalid PassKey. Please try again.', 'error');
      return; // Stop execution, no refresh
    }

    await Swal.fire('Success!', 'PassKey is valid. Proceeding with OTP...', 'success');

    // Now ask for OTP confirmation
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'You are about to send warrant OTP to buyer',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, proceed',
      cancelButtonText: 'No, cancel'
    });

    if (!result.isConfirmed) {
      console.log('User canceled OTP request');
      return;
    }

    console.log(this.warrantNumber);

    // Call the OTP API
    const url = `${config.serverURI}/qrcode/${this.warrantNumber}`;
    const otpResponse = await axios.get(url);

    if (otpResponse.data.error) {
      await Swal.fire('Error', otpResponse.data.message, 'error');
      return; // Stop execution, no refresh
    }

    await Swal.fire('Success!', otpResponse.data.message, 'success');

  } catch (error) {
    console.error('PassKey validation error:', error);
    await Swal.fire('Error!', error.response?.data?.message || 'Something went wrong while validating the PassKey.', 'error');
  }
}





















    }
  }
</script>

<style scoped>

</style>
